import * as d3 from 'd3'
export default {
  methods: {

    sitemap_Router(dia) {
      
      this.service = {usedList: [], usedCount: 0}

      const dia_tblList = [
        ...new Set(this.db_Table.filter(f=> f.DIAGRAM == dia.DIAGRAM && f.TYPE != 'Excel' && f.TYPE != 'Procedure').map(m => `${m.DATABASE}|${m.SCHEMA}|${m.NAME}`))
      ].map(key => {
        const [DATABASE, SCHEMA, NAME] = key.split('|')
        return { DATABASE, SCHEMA, NAME }
      })

      let targetSet = new Set(dia_tblList.map(m=> `${m.DATABASE}_${m.SCHEMA}_${m.NAME}`))
      this.service.usedList = this.db_Service.filter(f => targetSet.has(`${f.DATABASE}_${f.SCHEMA}_${f.TABLE}`))


      this.sitemapCanvas = this.canvasForms
      .append('g')
      .attr('transform', `translate(50, ${this.config.sitemap.y})`)

      this.gmx_Line(this.sitemapCanvas, -10, this.Canvas.CanvasWidth-80, -30, -30, '#bcbcbc', .5, 1)

      this.sitemapCanvas
      .append('text')
      .attr('id', `USED_NO`)
      .attr('x', 0).attr('y', 450).attr('fill', '#B4E3FA').attr('font-size', 50)
      .text(0)

      this.sitemapCanvas
      .append('text')
      .attr('x', 0).attr('y', 463).attr('fill', '#44A9DF').attr('font-size', 11)
      .text('No. of Components used')

      this.phase.list.forEach(d=> {

        let phaseGroup = this.sitemapCanvas
        .append('g')
        .attr('transform', `translate(${d.mx}, ${d.my})`)

        phaseGroup
        .append('text')
        .attr('fill', '#000').attr('font-size', 15).attr('font-weight', 500)
        .text(d.phase)

        this.draw_Group(phaseGroup, d.phase) // ----->
      })

      d3.select(`#USED_NO`).text(this.service.usedCount)
    },


    draw_Group(selection, phase_) {

      let group = [ ...new Set(this.db_Navigation.filter(f=> f.PHASE == phase_).map(d => d.GROUP)) ]
      let y_ = 25
      group.forEach(d=> {

        if(phase_=='System' && d!='Monthly Report') return
        let menuGroup = selection
        .append('g')
        .attr('transform', `translate(0, ${y_})`)

         menuGroup
        .append('text')
        .attr('fill', '#333').attr('font-size', 11)
        .text(d)

        let itemList =this.db_Navigation.filter(f=> f.PHASE == phase_ && f.GROUP == d && f.STATUS == 'SERVICE')

        this.draw_Item(menuGroup, itemList) // ----->

        y_ += (itemList.length * 20) + 30
      })
      
    },


    draw_Item(selection, itemList) {

      let y_ = 17
      itemList.forEach(d=> {

        let count = this.service.usedList.filter(f=> f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM).length
        this.service.usedCount += count 

        selection
        .append('text')
        .attr('id', `ITEM_${d.IDX}`)
        .attr('x', 0).attr('y', y_)
        .attr('fill', count>0 ? '#44A9DF' : '#E0E0DF').attr('font-size', 10)
        .text(count>0 ? `${d.ITEM} (${count})` : d.ITEM)
        .call(this.call_ServiceItem, d)
        
        y_ += 20
      })

      
    },

  }
}